import script from "./DialogContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./DialogContainer.vue?vue&type=script&lang=ts&setup=true"

import "./DialogContainer.vue?vue&type=style&index=0&id=7e95cf9e&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e95cf9e"]])

export default __exports__